import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Public, unauthenticated Statuspage API for GitHub's own platform status
// (https://www.githubstatus.com) — a separate host from this app's internal
// services, so it gets its own slice rather than being injected into
// platformServiceApiSlice/orgServiceApiSlice/userServiceApiSlice. No AD bearer
// token or correlation-id header is sent here; those are internal-service
// concerns and this is a third-party public endpoint.
export const githubStatusApiSlice = createApi({
  reducerPath: "githubStatusApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://www.githubstatus.com/api/v2",
  }),
  endpoints: () => ({}),
});
